export default __webpack_public_path__ + "static/media/power-radar-logo.f2760c28.png";